const INDUSTRIES = [
  { icon: "ri-hospital-line", name: "Medical & Healthcare" },
  { icon: "ri-building-line", name: "Construction" },
  { icon: "ri-calculator-line", name: "Accounting & Finance" },
  { icon: "ri-scales-3-line", name: "Legal" },
  { icon: "ri-car-line", name: "Automotive" },
  { icon: "ri-parking-box-line", name: "Parking Systems" },
  { icon: "ri-microscope-line", name: "Instruments & Lab" },
  { icon: "ri-shopping-bag-3-line", name: "Retail" },
  { icon: "ri-home-4-line", name: "Real Estate" },
  { icon: "ri-plane-line", name: "Aviation & Airports" },
  { icon: "ri-truck-line", name: "Logistics & Transport" },
  { icon: "ri-restaurant-line", name: "Hospitality" },
  { icon: "ri-flask-line", name: "Manufacturing" },
  { icon: "ri-broadcast-line", name: "Media & Broadcast" },
  { icon: "ri-graduation-cap-line", name: "Education" },
  { icon: "ri-shield-star-line", name: "Defense & Public Safety" },
];

export default function Industries() {
  return (
    <section id="industries" className="relative py-20 md:py-32 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-primary-600 font-semibold mb-4">
              <span className="w-8 h-px bg-primary-500"></span>
              Industries served
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
              Different industries, <br className="hidden md:block" />
              <span className="text-primary-600">the same principles.</span>
            </h2>
            <p className="mt-4 md:mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
              Every sector has its own quirks and regulations — but the fundamentals of
              secure, resilient and well-run technology are universal. I've applied them
              across dozens of industries and counting.
            </p>

            <div className="mt-8 md:mt-10 rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 flex-shrink-0">
                  <i className="ri-double-quotes-l text-2xl"></i>
                </div>
                <div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed italic">
                    "Great technology isn't about the newest gear — it's about understanding
                    the business it serves, and building something people can actually
                    depend on."
                  </p>
                  <div className="mt-3 text-xs md:text-sm font-semibold text-foreground-950">
                    Alon Hahamy
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
              {INDUSTRIES.map((ind) => (
                <div
                  key={ind.name}
                  className="group flex flex-col items-center justify-center text-center rounded-lg bg-background-50 border border-background-200 p-4 md:p-5 min-h-[120px] md:min-h-[140px] hover:border-primary-400 hover:-translate-y-1 transition-all"
                >
                  <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-colors">
                    <i className={`${ind.icon} text-2xl`}></i>
                  </div>
                  <div className="mt-3 text-xs md:text-sm font-semibold text-foreground-800 leading-tight">
                    {ind.name}
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-6 text-xs md:text-sm text-foreground-600 text-center md:text-right">
              …and many more.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}